import { useCallback, useEffect, useState } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { lenisRef } from "@/lib/lenis";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import TrustBar from "@/components/TrustBar";
import HowItWorks from "@/components/HowItWorks";
import Services from "@/components/Services";
import About from "@/components/About";
import Reviews from "@/components/Reviews";
import Commercial from "@/components/Commercial";
import Footer from "@/components/Footer";
import BookingModal from "@/components/BookingModal";
import WhatsAppFloat from "@/components/WhatsAppFloat";

function App() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const openBooking = useCallback(() => setBookingOpen(true), []);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  return (
    <div className="App font-body bg-[#F9F6F0] text-[#1A1A1A] antialiased selection:bg-[#B08D2E] selection:text-[#F9F6F0]">
      <Header onBook={openBooking} />
      <main>
        <Hero onBook={openBooking} />
        <TrustBar />
        <HowItWorks />
        <Services onBook={openBooking} />
        <About />
        <Reviews />
        <Commercial />
      </main>
      <Footer />
      <BookingModal open={bookingOpen} onOpenChange={setBookingOpen} />
      <WhatsAppFloat />
      <Toaster position="top-center" theme="light" />
    </div>
  );
}

export default App;
